// ─── Domain type for a media library image ──────────────────────────────────

export interface MediaImage {
  id: string;
  name: string;
  url: string;
  storagePath: string;
  size: number;
  mimeType: string;
  uploadedAt: Date;
  uploadedBy: string;
  tags?: string[];
}

// ─── Upload state ─────────────────────────────────────────────────────────────

export interface UploadProgress {
  file: File;
  progress: number; // 0-100
  status: 'uploading' | 'done' | 'error';
  errorMsg?: string;
  result?: MediaImage;
}

// ─── Helpers ──────────────────────────────────────────────────────────────────

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export const ALLOWED_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/svg+xml',
];
export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB
